import React, { useState, FormEvent } from "react";
import { ROUTES } from "../../constants/routes";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import {Backdrop, CircularProgress} from "@mui/material";

function currentYear() {
    const date = new Date()
    return date.getFullYear();
}

export const Login = () => {
    const {login} = useAuth();

    const navigate = useNavigate();
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        try {
            const result = await login(username, password);
            setIsLoading(false);
            if (result) {
                navigate(ROUTES.HOME.path);
            }
            else {
                setError("Неверный логин или пароль");
            }
        }catch (err) {
            setError("Неверный логин или пароль");
        } finally {
            setIsLoading(false);

        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginBox}>
                <h2 className={styles.title}>Вход в систему</h2>
                <form onSubmit={handleSubmit}>
                    <div className={styles.inputGroup}>
                        <input
                            type="text"
                            placeholder="Логин"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className={styles.inputGroup}>
                        <input
                            type="password"
                            placeholder="Пароль"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button type="submit" className={styles.loginButton} disabled={isLoading}>
                        Войти
                    </button>
                    {error && <p className={styles.error}>{error}</p>}
                </form>

                <p className={styles.footerText}>ВСГУТУ/ЭкоАльянс {currentYear()}</p>
            </div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1000 })}
                open={isLoading}

            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};